import useSWR, { SWRResponse } from "swr";
import AuthProvider from '/src/components/AuthProvider'
import { User } from "../types";
// @ts-ignore
import useHttpClient from "./useHttpClient";
import { AxiosInstance } from "axios";

const useUser = (enabled: boolean = true): SWRResponse<User, Error> => {
  const user = AuthProvider.getUser();
  const httpClient: AxiosInstance = useHttpClient();
  const data = useSWR(
    enabled && user ? "user" : null,
    enabled && user ? (): Promise<User> => httpClient.get("/users/me").then((res) => res.data.data) : null,
    {
      // Refetch on tab focus so balance/credit reflects admin-side changes
      // (e.g. loan approval) without a manual reload.
      revalidateOnFocus: true,
      revalidateIfStale: true,
      revalidateOnReconnect: true,
    }
  );
  return data;
};

export default useUser;
